<template>
  <div v-if="content" class="video" v-editable="content">
    <div v-if="!isPlaying" @click.prevent="playVideo()" class="video-controls">
      <fai class="icon" icon="play"></fai>
    </div>
    <video @click.prevent="pauseVideo()" ref="video" :width="content.width" :height="content.height" muted>
      <source :src="content.file" type="video/mp4">
    </video>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  },
  data() {
    return {
      isPlaying: false
    };
  },
  computed: {
  },
  methods: {
    toggleVideo(evt) {
      evt.target.paused ? evt.target.play() : evt.target.pause();
    },
    playVideo() {
      this.$refs.video.play();
      this.isPlaying = true
    },
    pauseVideo() {
      this.$refs.video.pause();
      this.isPlaying = false
    }
  }
};
</script>

<style lang="scss">
.video {
  cursor:pointer;
  margin: 1em auto;
  position: relative;
  width: $content-width;
  max-width:$max-width;
  video {
    object-fit: fill;
    max-width: 100%;
  }
  .video-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 3333;

    .icon {
      color: #fff;
      font-size: 50px;
    }
  }
}
</style>
